import React, { useId } from "react";

const ACTION_SIZE_PX = 30;
const RING_STROKE_PX = 1.4;
const RING_MID_STOP = 0.42;
const RING_COLORS = ["#ff5fae", "#c14bff", "#7a3cff"];
const RING_LOCATIONS = [0, RING_MID_STOP, 1];
const RING_START = { x: 0.25, y: 0.067 };
const RING_END = { x: 0.75, y: 0.933 };
const CENTER = ACTION_SIZE_PX / 2;
const RADIUS = (ACTION_SIZE_PX - RING_STROKE_PX) / 2;

export const DISCOVER_CHATBOT_CARD_PERSONALITY_GLOW_CLASS_NAME = "shadow-[0_0_10px_-1px_rgba(177,75,255,0.55),0_0_20px_-4px_rgba(255,95,174,0.45)]";

const DiscoverChatbotPersonalityRing = ({ "data-testid": testId }: { "data-testid"?: string }) => {
  const gradientId = useId();

  return (
    <svg
      className="pointer-events-none absolute inset-0"
      width={ACTION_SIZE_PX}
      height={ACTION_SIZE_PX}
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
    >
      <defs>
        <linearGradient id={gradientId} x1={RING_START.x} y1={RING_START.y} x2={RING_END.x} y2={RING_END.y}>
          {RING_COLORS.map((color, index) => (
            <stop key={color} offset={RING_LOCATIONS[index]} stopColor={color} />
          ))}
        </linearGradient>
      </defs>
      <circle cx={CENTER} cy={CENTER} r={RADIUS} stroke={`url(#${gradientId})`} strokeWidth={RING_STROKE_PX} fill="none" />
    </svg>
  );
};

export default React.memo(DiscoverChatbotPersonalityRing);
